'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactProps = require('./reactProps');

var _reactProps2 = _interopRequireDefault(_reactProps);

var _isCustomProp = require('../common/isCustomProp');

var _isCustomProp2 = _interopRequireDefault(_isCustomProp);

var _htmlAttributes = require('./htmlAttributes');

var _htmlAttributes2 = _interopRequireDefault(_htmlAttributes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (elem, prop) {
  return _reactProps2.default.has(prop) || _htmlAttributes2.default['*'].has(prop) || (typeof elem === 'string' ? _htmlAttributes2.default[elem] && _htmlAttributes2.default[elem].has(prop) : prop in elem) || (0, _isCustomProp2.default)(prop.toLowerCase());
};